import { c as _c } from "react/compiler-runtime";
import { getOrgTagsOptions } from '@onefootprint/fetch-dashboard';
import { Popover } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useEntitiesQueryParams, { EntityStatusFilter } from '@/components/entities/hooks/use-entities-query-params';
import FilterButton from '@/components/filter-button';
import ToggleGroup from '@/components/toggle-group';
import { useEntitiesContext } from '@/entities/components/list/hooks/use-entities-context';
import useMobileLayout from '@/hooks/use-mobile-layout';
import DrawerFilter from './components/drawer-filter';
import Info from './components/info';
import useManualReview from './hooks/use-manual-review';
export enum EntityWatchlistHitStatus {
  onWatchlist = 'true',
  notOnWatchlist = 'false',
}
export enum EntityHasOutstandingWorkflowRequestStatus {
  yes = 'true',
  no = 'false',
}
export enum ShowUnverifiedStatus {
  yes = 'true',
  no = 'false',
}
export enum RequiresManualReviewStatus {
  requiresManualReview = 'true',
  doesNotRequireManualReview = 'false',
}
const Filters = () => {
  const $ = _c(92);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.entities.filters"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const queryParams = useEntitiesQueryParams();
  const context = useEntitiesContext();
  const manualReviewQuery = useManualReview(context.kind);
  let t1;
  if ($[1] !== context.kind) {
    t1 = getOrgTagsOptions({
      query: {
        kind: context.kind
      }
    });
    $[1] = context.kind;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tagsQuery = useQuery(t1);
  const tags = tagsQuery.data;
  const isAll = !queryParams.values.state && !queryParams.values.verification;
  const isBusinesses = context.kind === "business";
  const isMobile = useMobileLayout();
  const [statusOpen, setStatusOpen] = useState(false);
  let t2;
  if ($[3] !== queryParams.values.requiresManualReview || $[4] !== queryParams.values.state || $[5] !== queryParams.values.verification) {
    t2 = [queryParams.values.state, queryParams.values.verification, queryParams.values.requiresManualReview].filter(Boolean);
    $[3] = queryParams.values.requiresManualReview;
    $[4] = queryParams.values.state;
    $[5] = queryParams.values.verification;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const statusCount = t2.length;
  const t3 = isMobile ? "flex flex-col items-start gap-4 p-4" : "flex flex-wrap gap-2";
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      value: "all",
      label: "All"
    }];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isBusinesses ? "all-businesses" : "all-individuals";
  const t6 = isAll ? "all" : undefined;
  let t7;
  if ($[8] !== queryParams) {
    t7 = () => {
      queryParams.push({
        state: undefined,
        verification: undefined,
        cursor: undefined,
        requiresManualReview: undefined
      });
    };
    $[8] = queryParams;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <ToggleGroup options={t4} groupId={t5} value={t6} onChange={t7} />;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = isBusinesses ? "state-businesses" : "state-individuals";
  const t10 = queryParams.values.state;
  let t11;
  if ($[14] !== t) {
    t11 = t(_temp);
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = {
      value: EntityStatusFilter.complete,
      label: t11
    };
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t) {
    t13 = t(_temp2);
    $[18] = t;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = {
      value: EntityStatusFilter.incomplete,
      label: t13
    };
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t12 || $[23] !== t14) {
    t15 = [t12, t14];
    $[22] = t12;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== queryParams) {
    t16 = newValue => {
      const newVerification = newValue === EntityStatusFilter.incomplete ? undefined : queryParams.values.verification;
      queryParams.push({
        state: newValue,
        verification: newVerification,
        cursor: undefined,
        requiresManualReview: newValue === EntityStatusFilter.incomplete ? false : queryParams.values.requiresManualReview
      });
    };
    $[25] = queryParams;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== queryParams.values.state || $[28] !== t15 || $[29] !== t16 || $[30] !== t9) {
    t17 = <ToggleGroup groupId={t9} value={t10} options={t15} onChange={t16} />;
    $[27] = queryParams.values.state;
    $[28] = t15;
    $[29] = t16;
    $[30] = t9;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = isBusinesses ? "verification-businesses" : "verification-individuals";
  const t19 = queryParams.values.verification;
  const t20 = queryParams.values.state === EntityStatusFilter.incomplete;
  let t21;
  if ($[32] !== t) {
    t21 = t(_temp3);
    $[32] = t;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t21) {
    t22 = {
      value: EntityStatusFilter.pass,
      label: t21
    };
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t) {
    t23 = t(_temp4);
    $[36] = t;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t23) {
    t24 = {
      value: EntityStatusFilter.failed,
      label: t23
    };
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t) {
    t25 = t(_temp5);
    $[40] = t;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t25) {
    t26 = {
      value: EntityStatusFilter.none,
      label: t25
    };
    $[42] = t25;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== t22 || $[45] !== t24 || $[46] !== t26) {
    t27 = [t22, t24, t26];
    $[44] = t22;
    $[45] = t24;
    $[46] = t26;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== queryParams) {
    t28 = newValue_0 => {
      const isSame = queryParams.values.verification === newValue_0;
      queryParams.push({
        cursor: undefined,
        verification: isSame ? undefined : newValue_0,
        state: EntityStatusFilter.complete
      });
    };
    $[48] = queryParams;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== queryParams.values.verification || $[51] !== t18 || $[52] !== t20 || $[53] !== t27 || $[54] !== t28) {
    t29 = <ToggleGroup groupId={t18} value={t19} disabled={t20} options={t27} onChange={t28} />;
    $[50] = queryParams.values.verification;
    $[51] = t18;
    $[52] = t20;
    $[53] = t27;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  const t30 = isBusinesses ? "mr-businesses" : "mr-individuals";
  const t31 = queryParams.values.requiresManualReview ? "true" : undefined;
  const t32 = queryParams.values.state === EntityStatusFilter.incomplete;
  let t33;
  if ($[56] !== t) {
    t33 = t(_temp6);
    $[56] = t;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  const t34 = manualReviewQuery.data?.data?.count;
  const t35 = manualReviewQuery.data?.data?.hasMore;
  let t36;
  if ($[58] !== manualReviewQuery.isLoading || $[59] !== t33 || $[60] !== t34 || $[61] !== t35) {
    t36 = [{
      value: "true",
      label: t33,
      count: t34,
      hasMore: t35,
      countLoading: manualReviewQuery.isLoading
    }];
    $[58] = manualReviewQuery.isLoading;
    $[59] = t33;
    $[60] = t34;
    $[61] = t35;
    $[62] = t36;
  } else {
    t36 = $[62];
  }
  let t37;
  if ($[63] !== queryParams) {
    t37 = () => {
      const nextValue = !queryParams.values.requiresManualReview;
      const getNextState = () => {
        if (nextValue && !queryParams.values.state) {
          return EntityStatusFilter.complete;
        }
        return queryParams.values.state;
      };
      queryParams.push({
        cursor: undefined,
        requiresManualReview: nextValue,
        state: getNextState()
      });
    };
    $[63] = queryParams;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  let t38;
  if ($[65] !== t30 || $[66] !== t31 || $[67] !== t32 || $[68] !== t36 || $[69] !== t37) {
    t38 = <ToggleGroup groupId={t30} value={t31} disabled={t32} options={t36} onChange={t37} />;
    $[65] = t30;
    $[66] = t31;
    $[67] = t32;
    $[68] = t36;
    $[69] = t37;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== t17 || $[72] !== t29 || $[73] !== t3 || $[74] !== t38 || $[75] !== t8) {
    t39 = <div className={t3}>{t8}{t17}{t29}{t38}</div>;
    $[71] = t17;
    $[72] = t29;
    $[73] = t3;
    $[74] = t38;
    $[75] = t8;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  const statusControls = t39;
  let t40;
  if ($[77] !== isMobile || $[78] !== statusControls || $[79] !== statusCount || $[80] !== statusOpen || $[81] !== t) {
    t40 = isMobile ? <Popover side="bottom" controlledOpen={statusOpen} onControlledOpenChange={setStatusOpen} onEscapeKeyDown={() => setStatusOpen(false)} content={<div className="max-w-[calc(100vw-2rem)]">{statusControls}</div>}><FilterButton hasFilters={statusCount > 0} aria-label={t(_temp7)}>{`${t(_temp8)}${statusCount > 0 ? ` (${statusCount})` : ""}`}</FilterButton></Popover> : statusControls;
    $[77] = isMobile;
    $[78] = statusControls;
    $[79] = statusCount;
    $[80] = statusOpen;
    $[81] = t;
    $[82] = t40;
  } else {
    t40 = $[82];
  }
  let t41;
  if ($[83] !== queryParams.isReady || $[84] !== tags) {
    t41 = queryParams.isReady && tags && <DrawerFilter tags={tags} />;
    $[83] = queryParams.isReady;
    $[84] = tags;
    $[85] = t41;
  } else {
    t41 = $[85];
  }
  let t42;
  if ($[86] !== t40 || $[87] !== t41) {
    t42 = <div className="flex flex-wrap items-center gap-2">{t40}{t41}</div>;
    $[86] = t40;
    $[87] = t41;
    $[88] = t42;
  } else {
    t42 = $[88];
  }
  let t43;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Info />;
    $[89] = t43;
  } else {
    t43 = $[89];
  }
  let t44;
  if ($[90] !== t42) {
    t44 = <div className="flex flex-col gap-3">{t42}{t43}</div>;
    $[90] = t42;
    $[91] = t44;
  } else {
    t44 = $[91];
  }
  return t44;
};
export default Filters;
function _temp($) {
  return $.status.complete;
}
function _temp2($_0) {
  return $_0.status.incomplete;
}
function _temp3($_1) {
  return $_1.status.pass;
}
function _temp4($_2) {
  return $_2.status.failed;
}
function _temp5($_3) {
  return $_3.status.none;
}
function _temp6($_4) {
  return $_4.status.manualReview;
}
function _temp7($_5) {
  return $_5.statusFilter;
}
function _temp8($_6) {
  return $_6.statusFilter;
}